<template>
  <div>
    <el-card class="box-card">
      <el-row>
        <el-col :span="24"><div class="s-title">消费者心声</div></el-col>
      </el-row>
      <div class="line-table">
        <el-row>
          <el-col :span="6"><div class="axis">X轴：BUZZ，Y轴：NWR</div></el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <div class="label-opt">
              <div class="label">品牌：</div>
              <div class="sel-opt">
                <el-select v-model="brandval" placeholder="请选择">
                  <el-option v-for="item in brandList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div class="label-opt">
              <div class="label">SKU：</div>
              <div class="sel-opt">
                <el-select v-model="skuval" placeholder="请选择">
                  <el-option v-for="item in skuList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
          </el-col>
          <el-col :span="21">
            <PointChart />
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24"><div class="s-title">商品口碑评价明细</div></el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <div class="sel-label flex-cen-left">
              <div class="label-opt">
                <div class="label">品类：</div>
                <div class="sel-opt">
                  <el-select v-model="cateval" placeholder="请选择">
                    <el-option v-for="item in cateList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="label-opt">
                <div class="label">SKU：</div>
                <div class="sel-opt">
                  <el-select v-model="wordskuval" placeholder="请选择">
                    <el-option v-for="item in skuList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="sel-label flex-cen-left">
              <div class="label-opt">
                <div class="label">维度：</div>
                <div class="sel-opt">
                  <el-select v-model="dimenval" placeholder="请选择">
                    <el-option v-for="item in dimenList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="label-opt">
                <div class="label">属性：</div>
                <div class="sel-opt">
                  <el-select v-model="attrval" placeholder="请选择">
                    <el-option v-for="item in attrList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="18">
            <el-table :data="tableData" style="width: 100%" class="eltable">
              <el-table-column prop="sku" label="SKU" width="180"></el-table-column>
              <el-table-column prop="dmien" label="维度" width="180"></el-table-column>
              <el-table-column prop="attr" label="属性"></el-table-column>
              <el-table-column prop="date" label="日期"></el-table-column>
              <el-table-column prop="time" label="时间"></el-table-column>
              <el-table-column prop="content" label="内容"></el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import PointChart from './components/PointChart'
export default {
  components: { PointChart },
  data() {
    return {
      queryInfo: {// pagination
        query: '',
        pagenum: 1,
        pagesize: 10,
      },
      currentPage: 1,// current page
      total: 0,// total
      rules: {},// rule
      form: {},// form
      loading: true,
      brandList: [// 品牌
        {
          value: 0,
          label: '品牌T'
        },
        {
          value: 1,
          label: '品牌T'
        }
      ],
      brandval: 0,// 品牌
      skuList: [// SKU
        {
          value: 0,
          label: '1'
        },
        {
          value: 1,
          label: '2'
        }
      ],
      skuval: 0,// SKU
      cateList: [// 品类
        {
          value: 0,
          label: '女装'
        },
        {
          value: 1,
          label: '男装'
        }
      ],
      cateval: 0,// 品类
      wordskuval: '',// SKU
      dimenList: [// 维度
        {
          value: 0,
          label: '所有'
        },
        {
          value: 1,
          label: '所有'
        }
      ],
      dimenval: 0,// 维度
      attrList: [// 属性
        {
          value: 0,
          label: '所有'
        },
        {
          value: 1,
          label: '所有'
        }
      ],
      attrval: 0,// 属性
      tableData: [{
        sku: '1',
        dmien: '产品设计',
        attr: '口袋',
        date: '2019年7月30日',
        time: '0:19:38',
        content: '因数据敏感度原因评价内容无法展示'
      }, 
      {
        sku: '2',
        dmien: '产品设计',
        attr: '口袋',
        date: '2019年8月9日',
        time: '23:23:30',
        content: '因数据敏感度原因评价内容无法展示'
      }, 
      {
        sku: '3',
        dmien: '产品设计',
        attr: '拉链',
        date: '2019年8月2日',
        time: '16:04:13',
        content: '因数据敏感度原因评价内容无法展示'
      }, 
      {
        sku: '4',
        dmien: '产品设计',
        attr: '拉链',
        date: '2019年8月9日',
        time: '9:02:41',
        content: '因数据敏感度原因评价内容无法展示'
      },
      {
        sku: '5',
        dmien: '产品设计',
        attr: '领口',
        date: '2019年8月9日',
        time: '23:23:30',
        content: '因数据敏感度原因评价内容无法展示'
      },
      {
        sku: '6',
        dmien: '产品设计',
        attr: '图案',
        date: '2019年8月22日',
        time: '11:51:47',
        content: '因数据敏感度原因评价内容无法展示'
      },
      {
        sku: '7',
        dmien: '产品设计',
        attr: '图案',
        date: '2019年8月28日',
        time: '17:13:59',
        content: '因数据敏感度原因评价内容无法展示'
      },
      {
        sku: '8',
        dmien: '产品设计',
        attr: '细节',
        date: '2019年8月2日',
        time: '16:04:13',
        content: '因数据敏感度原因评价内容无法展示'
      },]
    }
  },
  created() {
    
  },
  methods: {

  }
}
</script>

<style lang="scss" src="../assets/common.scss" scoped></style>
<style lang="scss" scoped>
.box-card{
  background-color: #F3F2F1;
  .s-title{
    width: 10rem;
    text-align: center;
    padding: 0.8rem 1rem;
    border-radius: 10px;
    margin: 1rem 0;
    font-size: 18px;
    background-color: #FBFBFB;
  }
  .line-table{
    background-color: #F7F6F6;
    padding: 2rem 1rem;
    .label-opt{
      margin-bottom: 2rem;
    }
    .axis{
      margin-bottom: 1rem;
    }
    .label-opt{
      margin-right: 1rem;
      .label{
        margin-bottom: 0.5rem;
      }
      .sel-opt{
        width: 10rem;
      }
    }
    .eltable{
      >>>.el-table__header-wrapper{
        thead{
          tr{
            th{
              border-bottom: 2px solid #989ABC;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/voc/wordmouth/index.vue